import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/CookieBanner.css";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Webgune honek funtzionamendurako beharrezko cookie teknikoak erabiltzen
        ditu. Informazio gehiago{" "}
        <Link to="/cookies-policy">cookie-politikan</Link>.
      </p>
      <button onClick={acceptCookies}>Onartu</button>
    </div>
  );
}